import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { RxStompService } from 'src/app/stomp/rx-stomp.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {

  constructor(
    public spinnerService:NgxSpinnerService,
    private rxStompServive:RxStompService
  ) { }

  ngOnInit(): void {
    console.log('ThankYou Initialized')
    this.spinnerService.hide();
    this.rxStompServive.deactivate()
  }

}
